<template>
    <div>
        <b-table :items="data" :fields="columns" responsive striped hover empty-text="No hay datos para mostrar"
            show-empty>
            <template #cell(primary_field.value)="row">
                {{ row.item.primary_field.value || 'NO REGISTRA' }}
            </template>

            <template #cell(is_active)="row">
                <b-badge :variant="row.item.is_active ? 'success' : 'danger'">
                    {{ row.item.is_active ? 'Activo' : 'Inactivo' }}
                </b-badge>
            </template>

            <template #cell(actions)="row">
                <el-tooltip class="mx-1" effect="dark" placement="top" content="Editar" popper-class="py-1 px-2">
                    <i @click="$emit('edit', row.item)" class="fa fa-edit fa-lg text-info mr-1 cursor-pointer" />
                </el-tooltip>

                <el-tooltip class="mx-1" effect="dark" placement="top"
                    :content="row.item.is_active ? 'Inactivar' : 'Activar'" popper-class="py-1 px-2">
                    <i @click="$emit('change-status', row.item)"
                        :class="['fa', row.item.is_active ? 'fa-times-circle-o text-danger' : 'fa-check-circle-o text-success', 'fa-lg', 'mr-1', 'cursor-pointer']" />
                </el-tooltip>
            </template>
        </b-table>

        <el-pagination class="d-flex justify-content-md-end justify-content-center align-items-center"
            :current-page.sync="pagination.page" :page-size.sync="pagination.per_page" :total="pagination.total"
            layout="total, sizes, prev, pager, next" @size-change="$emit('size-change', $event)"
            @current-change="$emit('page-change', $event)" :page-sizes="[10, 20, 50, 100]" />
    </div>
</template>

<script>
export default {
    name: "DataTable",
    props: {
        columns: {
            type: Array,
            required: true,
        },
        data: {
            type: Array,
            required: true,
        },
        pagination: {
            type: Object,
            required: true,
        },
    },
    methods: {
        formatDate(date) {
            return new Date(date).toLocaleDateString()
        }
    }
};
</script>
